import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/commons/generic.service';
import { PartConselhoPosRecadDTO } from 'app/components/pos-recadastramento/aba11-posrecad/partConselhoPosRecad.dto';
import { ArquivoBlobDTO } from 'app/model/arquivoBlob.dto';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PosCampanhaAba11Service extends GenericService{

  private baseUrl = environment.url + 'api/v1';

  constructor(http: HttpClient) {
    super(http);
   }

    getObterConselhos(param: number): Observable<PartConselhoPosRecadDTO> {
        return this.getMethod<PartConselhoPosRecadDTO>(`api/v1/admin/validacao-recadastramento/conselho`, { validacaoRecadId: param });
    }

    postConselhos(body): Observable<any> {
        return this.http.post<any>(this.baseUrl + `/admin/validacao-recadastramento/conselho`, body);
    }

    // getObterArquivos(comprovante: string, recadValidacaoConselhoId): Observable<ArquivoBlobDTO> {
    //   const options = {
    //     responseType: 'blob' as 'json'
    //   };
    //   console.log(recadValidacaoConselhoId)
    //   return this.http.get<ArquivoBlobDTO>(this.url + `api/v1/admin/validacao-recadastramento/conselho/anexo/recadValidacaoConselhoId=${recadValidacaoConselhoId}`, options);
    // }
  
    salvarDocumentos(id, body): Observable<any> {
      return this.http.put<any>(this.baseUrl + `/admin/validacao-recadastramento/conselho/${id}`, body);
  }



  getObterArquivos(recadValidacaoConselhoId: number, comprovante: string): Observable<any> {
    const params = new HttpParams().set('recadValidacaoConselhoId', recadValidacaoConselhoId.toString());

    // Defina responseType como 'blob' para obter uma resposta binária
    const options = {
      responseType: 'blob' as 'json'
    };
    console.log(options)
    return this.http.get<ArquivoBlobDTO>(this.url + `api/v1/admin/validacao-recadastramento/conselho/anexo/`, {
        params,
        ...options })
}
}
